export const FRAX_RATE_CALCULATOR_ABI = [
  {
    inputs: [
      { internalType: 'string', name: '_suffix', type: 'string' },
      { internalType: 'uint256', name: '_vertexUtilization', type: 'uint256' },
      { internalType: 'uint256', name: '_vertexRatePercentOfDelta', type: 'uint256' },
      { internalType: 'uint256', name: '_minUtil', type: 'uint256' },
      { internalType: 'uint256', name: '_maxUtil', type: 'uint256' },
      { internalType: 'uint256', name: '_zeroUtilizationRate', type: 'uint256' },
      { internalType: 'uint256', name: '_minFullUtilizationRate', type: 'uint256' },
      { internalType: 'uint256', name: '_maxFullUtilizationRate', type: 'uint256' },
      { internalType: 'uint256', name: '_rateHalfLife', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'MAX_FULL_UTIL_RATE',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MAX_TARGET_UTIL',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MIN_FULL_UTIL_RATE',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MIN_TARGET_UTIL',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'RATE_HALF_LIFE',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'RATE_PREC',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'UTIL_PREC',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'VERTEX_RATE_PERCENT',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'VERTEX_UTILIZATION',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'ZERO_UTIL_RATE',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_deltaTime', type: 'uint256' },
      { internalType: 'uint256', name: '_utilization', type: 'uint256' },
      { internalType: 'uint64', name: '_oldFullUtilizationInterest', type: 'uint64' },
    ],
    name: 'getNewRate',
    outputs: [
      { internalType: 'uint64', name: '_newRatePerSec', type: 'uint64' },
      { internalType: 'uint64', name: '_newFullUtilizationInterest', type: 'uint64' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'suffix',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'version',
    outputs: [
      { internalType: 'uint256', name: '_major', type: 'uint256' },
      { internalType: 'uint256', name: '_minor', type: 'uint256' },
      { internalType: 'uint256', name: '_patch', type: 'uint256' },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
] as const
